import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import HomeView from "../screens/home/Home.View";
import RingHomeView from "../screens/home/RingHome.View";
import ContactView from "../screens/contact/Contact.View";
import Page404 from "../screens/home/Page404.View";
import ExternalRedirect from "../components/ExternalRedirect"; // ★追加

const Navigator = () => {
  const isRingOnly = process.env.REACT_APP_ENTRY === "ring";

  return (
    <Routes>
      {isRingOnly ? (
        <>
          <Route path="/" element={<Navigate to="/ring" />} />
          <Route path="/ring" element={<RingHomeView />} />

          <Route
            path="/ring/contact"
            element={
              <ExternalRedirect to="https://kortvaluta.com/contact_ring/" />
            }
          />

          <Route path="*" element={<Navigate to="/ring" />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate to="/wallet" />} />
          <Route path="/wallet" element={<HomeView />} />
          <Route path="/ring" element={<RingHomeView />} />
          <Route path="/wallet/contact" element={<ContactView isWallet />} />

          <Route
            path="/ring/contact"
            element={
              <ExternalRedirect to="https://kortvaluta.com/contact_ring/" />
            }
          />

          <Route path="*" element={<Page404 />} />
        </>
      )}
    </Routes>
  );
};

export default Navigator;
